var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.611,
    height: 26.611,
    viewBox: "0 0 26.611 26.611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-upload",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1693",
    d: "M28.111,22.5v5.247a2.623,2.623,0,0,1-2.623,2.623H7.123A2.623,2.623,0,0,1,4.5,27.747V22.5",
    transform: "translate(0 -2.259)",
    fill: "none",
    stroke: "#105dae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1694",
    d: "M23.617,11.059,17.059,4.5,10.5,11.059",
    transform: "translate(-0.753)",
    fill: "none",
    stroke: "#105dae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1695",
    d: "M18,4.5V20.241",
    transform: "translate(-1.694)",
    fill: "none",
    stroke: "#105dae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.80a6c414a0ba2cdb77e571cf47ebe871.svg";
export { ForwardRef as ReactComponent };